import React from 'react';
export const Footer = () => {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center" data-id="element-91">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-92">
        <h4 className="text-white font-heading font-bold text-xl mb-4" data-id="element-93">
          📚 PACK DOCENTE 2026 — MATEMÁTICA PRIMARIA CFE™
        </h4>
        <p className="mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-94">
          El sistema de planificación N°1 para docentes de matemática de nivel
          primario en Argentina. Porque enseñar bien no debería costarte los
          domingos ni la salud mental.
        </p>
        <div className="text-sm mb-8 space-x-2 md:space-x-4" data-id="element-95">
          <span data-id="element-96">soportenexorecursos.com</span>
          <span className="text-gray-600" data-id="element-97">•</span>
          <span data-id="element-98">@nexorecursoss</span>
          <span className="text-gray-600" data-id="element-99">•</span>
          <span data-id="element-100">nexorecursos.com</span>
        </div>
        <div className="text-xs text-gray-600 border-t border-gray-800 pt-8" data-id="element-101">
          © Pack Docente 2026 — Matemática Primaria CFE™ — Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
};